/**
 * Which sign-in situation the person is in.
 *
 * Three, not two, and the third is the one that decides whether signing in on
 * a phone works at all. DOQENT learned it in production: from a web app
 * installed on an iOS home screen, a link to another web app opens Safari
 * rather than that app. So there the six-digit code is not a fallback, it is
 * the whole path, and the button next to it copies rather than opens.
 *
 * Kept away from the component so the rule can be tested without a browser.
 */

export const DESKTOP = "desktop";
export const PHONE = "phone";
export const PHONE_INSTALLED = "phone-installed";

const PHONE_AGENT = /Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i;

export function describeDevice(nav, matchMedia) {
  const agent = nav?.userAgent ?? "";
  if (!PHONE_AGENT.test(agent)) {
    // A desktop can be installed too: Novamund's own app runs standalone. The
    // SPEAQ ID app still lives on another device, so the QR is right.
    return DESKTOP;
  }

  // Two ways to be installed, and iOS Safari only answers the older one.
  // Reading just the media query misses the exact case this exists for.
  const displayMode = typeof matchMedia === "function" ? matchMedia("(display-mode: standalone)") : null;
  const installed = Boolean(displayMode?.matches) || nav?.standalone === true;

  return installed ? PHONE_INSTALLED : PHONE;
}
